import moment from 'moment'
import { isIso8601Duration } from '../validator/is-iso-8601-duration'
import { DURATION_ZERO } from '../constants'

/**
 * Uses moment to add two moment.duration() objects and returns an ISO 8601 duration string. Non-ISO 8601 duration
 * string arguments will be treated as a duration of zero (P0D).
 *
 * @param {String} firstDuration - An ISO 8601 duration string.
 * @param {String} secondDuration - An ISO 8601 duration string.
 * @returns {string} A new ISO 8601 duration string that is the sum of the input.
 */
export const addDurationToDuration = (firstDuration, secondDuration) => {
    const castedFirstDuration = isIso8601Duration(firstDuration)
        ? moment.duration(firstDuration)
        : moment.duration(DURATION_ZERO)

    const castedSecondDuration = isIso8601Duration(secondDuration)
        ? moment.duration(secondDuration)
        : moment.duration(DURATION_ZERO)

    return castedFirstDuration.add(castedSecondDuration).toISOString()
}
